export default __webpack_public_path__ + "static/media/home1.00b117fd.jpg";